import { apiRequest } from "util/services";
import { extractWelcomeReviewsFromApiResponse } from "pages/Welcome/welcomeDrawerReviewDoc";

/** POST path for welcome workspace widget review drill-down by metric id. */
export function welcomeWidgetMetricReviewsPath(metricId) {
  const mid = Number(metricId);
  if (!Number.isFinite(mid) || mid <= 0) return null;
  return `welcome/widget/metric-${mid}/reviews`;
}

/**
 * Fetch reviews for a welcome widget metric (20, 23, 25, 27, 14, …).
 * Metric 14 responses may include `total` for pagination.
 */
export async function fetchWelcomeWidgetMetricReviews(
  metricId,
  payload,
  options = {},
) {
  const path =
    options.path ?? welcomeWidgetMetricReviewsPath(metricId);
  if (!path) {
    return { reviews: [], total: undefined, raw: null };
  }
  const resp = await apiRequest(
    path,
    "POST",
    payload,
    true,
    options.signal,
  );
  const reviews = extractWelcomeReviewsFromApiResponse(resp);
  const total =
    resp?.total != null && Number.isFinite(Number(resp.total))
      ? Number(resp.total)
      : undefined;
  return { reviews, total, raw: resp };
}
